import { toast } from 'react-toastify';
import styled, { css, keyframes } from 'styled-components';

type CreateNotificationType = {
  message: string;
  type: 'success' | 'error';
  position?: 'top-left' | 'top-center' | 'top-right' | 'bottom-left' | 'bottom-center' | 'bottom-right';
  duration?: number;
};

export const createNotification = ({ message, type = 'success', position, duration=9000 }: CreateNotificationType) => {
  toast(({ toastProps }) => (
    <S.NotificationWrapper visible={toastProps.isIn} type={type} onClick={() => toast.dismiss(toastProps.toastId)}>
      {message}
    </S.NotificationWrapper>
  ),
  { autoClose: duration, position: position || 'bottom-center', className: 'max-sm:!w-[95%] !w-[500px] !shadow-none p-6 max-sm:!m-4 max-sm:!p-4', closeButton: false, customProgressBar: true, style: { background: 'none', padding: 0 } }
  );
};

const animateIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(0px) scale(0.9);
  }

  to {
    opacity: 1;
    transform: translateY(-10px) scale(1);
  }
`;

const animateOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(-10px)
  }

  to {
    opacity: 0;
    transform: translateY(0px)
  }
`;

const S: any = {};

S.NotificationWrapper = styled.div`
 padding: 20px 30px;
  @media(min-width: 768px) {
    width: 100%;
    padding: 10px;

  }

  border-radius: 25px;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  opacity: 0;
  font-weight: 300;
  font-size: 1rem;
  text-align: center;

  ${(props: any) =>
    props.visible &&
    css`
      animation: ${animateIn} 0.2s ease-in-out;
      animation-fill-mode: forwards;
    `}

  ${(props: any) =>
    !props.visible &&
    css`
      animation: ${animateOut} 0.2s ease-in-out;
      animation-fill-mode: forwards;
    `}

  ${(props: any) =>
    props.type === 'success' &&
    css`
      background-image: var(--turquise-lime-gradient);
    `}

  ${(props: any) =>
    props.type === 'error' &&
    css`
      background-image: var(--red-pink-gradient);
      color: var(--white);
    `}

  @media(min-width: 768px) {
    font-size: 1.125rem;
  }
`;
